import { ModelCollectionBase } from '@artsman/ams-loader';

import { pivotable } from './decorators';

@pivotable
export class DefaultCollection extends ModelCollectionBase {}